import { AxiosResponse } from "axios";
import React, { ChangeEvent, useContext, useEffect, useState } from "react";
import { Row } from "reactstrap";
import { Modal } from "reactstrap";
import { Container } from "reactstrap";
import { User } from "../../models/AdminSettingsM/AdminSettingsModel";
import "./AdminSettings.scss";
import AdminSettingsList from "./AdminSettingsList";
import { toast } from "react-toastify";
import { Input } from "reactstrap";
// import UpdateUserForm from "./UpdateUserForm";
import { Nav, Tab } from "react-bootstrap";
import { Col } from "reactstrap";
//] import OrgChart from "./Organization/OrgChart";
import exitIcon from "../../images/exitIcon.svg";
import { APP_Config } from "../../utils/AppConfig";
import { BankUserContext } from "../../bankUserContext";
import Service from "../../services";
import UpdateUserForm from "./UpdateUserForm";

const AdminSettingsMaster: React.FC<any> = (props: any) => {
  const service = new Service();
  const bankUserContext = useContext(BankUserContext);
  const [createUserModal, setCreateUserModal] = useState(false);
  const [settingsData, setSettingsData] = useState<User[]>([]);
  const [refreshTable, setRefreshTable] = useState(false);
  const [activeKey, setActiveKey] = useState("adminSettings"); 
  const[searchVal, setSearchVal] = useState<string>("");
  const context = useContext(BankUserContext);


//   const getAllUsersByOrgId = ()=>{
// const payLoad={
//   screen: "admin settings",
// sections :"getUsersByRoles",
// orgId:context.bankuserDetails?.organization.orgId,
// }; 
//  service
//       .getLeadsData(payLoad)
//       .then((response: AxiosResponse) => {
//         setSettingsData(response?.data? response?.data: []);
//         setRefreshTable(false);
//       })
//       .catch((error: any) => {
//         toast.error(error.response.data.Errormessage);
//       });
    
//   };
  const getAllUsersByOrgId  = (search="")=>{
    let payLoad = {};
    if(search){
      payLoad={
        screen: "admin settings",
      sections :"getUsersByRoles",
      orgId:context.bankuserDetails?.organization.orgId,
      search,
      };  
    }
    else{
    payLoad={
        screen: "admin settings",
      sections :"getUsersByRoles",
      orgId:context.bankuserDetails?.organization.orgId,      
      };  
    } 
     service
          .getLeadsData(payLoad)
          .then((response: AxiosResponse) => {
            setSettingsData(response?.data? response?.data: []);
            setRefreshTable(false);
          })
          .catch((error: any) => {
            toast.error(error.response.data.Errormessage);
          });         
        
      };
    
    
  useEffect(() => {
    getAllUsersByOrgId();  
   //setActiveKey("orgChart");
  }, []);
  const closeToggle = () => {
    setCreateUserModal(false);
  };

  useEffect(() => {
    getAllUsersByOrgId();
    // if(bankUserContext.showOrgChart) setActiveKey("orgChart");
  }, [refreshTable]);

  const [orgChartRefresh, setOrgChartRefresh] = useState(false);
  const setOrgChartRefreshFunc = () => {
    setOrgChartRefresh(false);
  };
  const [displaySearch, setDisplaySearch] = useState(true);
  return (
    <>
      <Container fluid>
        <Row className="adminSettingHeaderRow">
          <div className="adminSettingHeader">
            <div className="leftSide ">
              <span>Admin Settings</span>
            </div>
            <span>
              {" "}
              <img src={exitIcon} alt=" closeIcon" />
            </span>
          </div>
        </Row>
        <Row>
          <Tab.Container activeKey={`${activeKey}`}>
            <Col className="navLinksSearch" md="12">
              <Nav variant="tabs">
                <Nav.Item              
                  onClick={() => {
                    setDisplaySearch(true);
                    setActiveKey("adminSettings");
                    // bankUserContext.setShowOrgChart(false);
                  }}
                >
                  <Nav.Link eventKey="adminSettings">All Users</Nav.Link>{" "}
                </Nav.Item>
                <Nav.Item onClick={() => setDisplaySearch(false)}>
                  <Nav.Link
                    eventKey="orgChart"
                    onClick={() => {
                      // setOrgChartRefresh(true);
                      setActiveKey("orgChart");
                      // bankUserContext.setShowOrgChart(true);
                    }}
                  >
                    Organization
                  </Nav.Link>{" "}
                </Nav.Item>
              </Nav>
              <span className="userSearch">
                {" "}
                {displaySearch && (
                  <Input
                    name="search"
                    id="search"
                    type="text"
                    placeholder={`Search by Name`}
                    onChange={(e: ChangeEvent<HTMLInputElement>) =>
                      getAllUsersByOrgId(e.target.value)
                    }
                  />
                )}
              </span>
            </Col>
            <Col>
              <Tab.Content>
                <Tab.Pane eventKey="adminSettings">
                  <AdminSettingsList
                    refresh={setRefreshTable}
                    settingsData={settingsData}
                    getAllUsersByOrgId={getAllUsersByOrgId}
                  />
                </Tab.Pane>
                <Tab.Pane eventKey="orgChart">
                  {/* <OrgChart orgChartRefresh={orgChartRefresh} setOrgChartRefresh={setOrgChartRefreshFunc} /> */}
                </Tab.Pane>
              </Tab.Content>
            </Col>
          </Tab.Container>
          <hr />
        </Row>
      </Container>

      {/* Modal for Create User */}
      <Modal
        fade={false}
        isOpen={createUserModal}
        toggle={() => setCreateUserModal((prev) => !prev)}
        className="modalCreate"
      >
        <UpdateUserForm
          setCreateUserModal={setCreateUserModal}
          closeToggle={closeToggle}
          getAllUsersByOrgId={getAllUsersByOrgId}
        />
      </Modal>
    </>
  );
};
export default AdminSettingsMaster;
